import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-settings-card',
  templateUrl: './settings-card.component.html',
  styleUrls: ['./settings-card.component.scss']
})
export class SettingsCardComponent implements OnInit {

  @Output() toggleOptionEvent = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  toggleOption(option: number) {
    this.toggleOptionEvent.emit(option);
  }

}
